import create from 'zustand'

import { StatusTypes, StatusErrorTypes } from 'types/status'
import { TraderContactDataTypes } from 'types/corporateContacts'

interface CorporateContactStoreTypes {
  corporateContactsModErrors: StatusErrorTypes
  corporateContactsModErrorsSet: (corporateContactsModErrors: StatusErrorTypes) => void
  corporateContactsModStatus: StatusTypes
  corporateContactsModStatusSet: (corporateContactsModStatus: StatusTypes) => void
  corporateContacts: TraderContactDataTypes[]
  corporateContactsSet: (corporateContacts: TraderContactDataTypes[]) => void
}

export const useCorporateContactsStore = create<CorporateContactStoreTypes>((set) => ({
  corporateContactsModErrors: '',
  corporateContactsModErrorsSet: (corporateContactsModErrors) => {
    set({ corporateContactsModErrors })
  },
  corporateContactsModStatus: 'idle',
  corporateContactsModStatusSet: (corporateContactsModStatus) => {
    set({ corporateContactsModStatus })
  },
  corporateContacts: [],
  corporateContactsSet: (corporateContacts) => {
    set({ corporateContacts })
  },
}))
